













import {
  Vue,
  Component
} from "@/shared/vuepack";
import { useDebitCardManagementStore } from "@/shared/store/debitCardManagement";
import { useThemeStore } from "@/shared/store/theme";

@Component({})
export default class PinSetCompleteForm extends Vue {
    debitCardManagementStore = useDebitCardManagementStore();
    themeStore = useThemeStore();
}
